import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  registrationBadge = 0;
  registrationBadgeLoading = false;
  registrationBadgeSuccess = false;
  emailBadge = 0;
  communicationBadge = false;
}
